































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Dashboard } from '@/api/model/dashboard'
import { ScheduledDashboardExportAPI } from '@/api/backend-client'
import { availableScheduledDashboardExportSchedules, ScheduledDashboardExportSchedule } from '@/api/types'

@Component
export default class DashboardBlock extends Vue {
    @Prop({ required: true }) dashboard!: Dashboard
    scheduled: boolean = null
    schedule: ScheduledDashboardExportSchedule = null
    saving: boolean = false

    mounted() {
        const scheduledDashboardExport = this.$currentUser.getScheduledDashboardExport(this.dashboard.id)
        if (scheduledDashboardExport) {
            this.scheduled = true
            this.schedule = scheduledDashboardExport.schedule
        } else {
            this.scheduled = false
            this.schedule = ScheduledDashboardExportSchedule.WEEKLY
        }
    }

    canBeScheduled(dashboard: Dashboard): boolean {
        return !!dashboard.cumulioExportId || !!dashboard.cumulioId
    }

    get scheduleOptions() {
        return availableScheduledDashboardExportSchedules().map(schedule => {
            return {
                label: this.$t(`reports.scheduleOptions.${schedule}.label`),
                value: schedule,
            }
        })
    }

    @Watch('scheduled')
    onScheduledChanged(scheduled, oldScheduled) {
        if (oldScheduled === null) {
            return
        }

        if (scheduled) {
            this.createScheduledDashboardExport()
        } else {
            this.deleteScheduledDashboardExport()
        }
    }

    @Watch('schedule')
    onScheduleChange(schedule, oldSchedule) {
        if (oldSchedule === null) {
            return
        }

        this.updateScheduledDashboardExport()
    }

    async createScheduledDashboardExport() {
        const scheduledDashboardExport = this.$currentUser.addScheduledDashboardExport(this.dashboard.id, this.schedule)

        this.saving = true
        await ScheduledDashboardExportAPI.create(scheduledDashboardExport)
        this.saving = false
    }

    async updateScheduledDashboardExport() {
        const scheduledDashboardExport = this.$currentUser.getScheduledDashboardExport(this.dashboard.id)
        if (!scheduledDashboardExport) {
            return
        }

        scheduledDashboardExport.schedule = this.schedule

        this.saving = true
        await ScheduledDashboardExportAPI.update(scheduledDashboardExport.id, scheduledDashboardExport)
        this.saving = false
    }

    async deleteScheduledDashboardExport() {
        const scheduledDashboardExport = this.$currentUser.removeScheduledDashboardExport(this.dashboard.id)
        if (!scheduledDashboardExport) {
            return
        }

        this.saving = true
        await ScheduledDashboardExportAPI.delete(scheduledDashboardExport.id)
        this.saving = false
    }
}
